// CONSTANTS FOR USER GROUPS
export const ADMIN = "Admin";
export const OWNER = "Owner";
export const SUB_ADMIN = "Sub Admin";
export const USER = "User";
